export const iconFontAwesomeArrowsArrowUpRightDots = (
	<i className="fa-solid fa-arrow-up-right-dots"></i>
);
